import { filterNonNullValues } from '@/lib/utils'
import UsersPage from '@/views/users'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/users/')({
  component: UsersPage,
  validateSearch: (search) => filterNonNullValues({
    page: search.page ? Number(search.page) : 0,
    page_size: search.page_size ? Number(search.page_size) : 10,
    ordering: typeof search.ordering === 'string' ? search.ordering : null,
    name: typeof search.name === 'string' ? search.name : null,
    is_active: Array.isArray(search.is_active) ? search.is_active : null,
    roles: Array.isArray(search.roles) ? search.roles : null
  }),
})
